module.exports = __webpack_public_path__ + "img/Newbie_Axe_02_Classic.76d54641.png";